var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('Tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('Tab',{attrs:{"title":"标签 1"}},[_vm._v("内容 1")]),_c('Tab',{attrs:{"title":"标签 2"}},[_vm._v("内容 2")]),_c('Tab',{attrs:{"title":"标签 3"}},[_vm._v("内容 3")]),_c('Tab',{attrs:{"title":"标签 4"}},[_vm._v("内容 4")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }